class SliderFlickity extends HTMLElement {
  constructor() {
    super();
    this.slider = this.querySelector('.multicolumn-slider-list');     
    this.sliderItems = this.querySelectorAll('.multicolumn-slider-list__item');
    this.sliderView = this.getAttribute('data-view');
    this.items = this.getAttribute('data-items');  
    this.d_items = this.getAttribute('data-desktop');    
    this.m_items = this.getAttribute('data-mobile');  
    this.sliderAlign = this.getAttribute('data-align');  
    this.window = window.innerWidth;
    this.options = {      
      cellAlign: this.sliderAlign,
      contain: true,
      wrapAround: true,
      fade: false,      
      pageDots: false,
      arrowShape: 'M96.8,55H22.3l37.4,37.4l-7.1,7.1L3.2,50L52.7,0.5l7.1,7.1L22.3,45h74.6V55z'
    }
    this.sliderInstance;    
    this.initPages();   
    let _this = this;
    
    window.addEventListener('resize', function(){      
      _this.initPages()
    });        
  }
  
  initPages(){   
    let isMobileOrTab = this.isMobileOrTab();       
    isMobileOrTab ? this.initSlider() : this.destroySlider();   
  }

  isMobileOrTab(){    
    let initSlider = false;    
    
    if(window.innerWidth < 749 && this.items > this.m_items){
    	initSlider = true;
    }
    else if(window.innerWidth < 989 && this.items > 3  && this.sliderView == 'desktop'){
    	initSlider = true;
    }
    else if(this.items > this.d_items && this.sliderView == 'desktop'){
    	initSlider = true;
    }
    else{
    	initSlider = false;
    }
    
    return initSlider;
  }
  
  initSlider(){
    setTimeout(() => {
      this.sliderInstance = new Flickity( this.slider, this.options );        
    }, 300);
    //this.sliderInstance = new Flickity( this.slider, this.options );        
  }
  
  destroySlider(){
    if(this.sliderInstance){
      console.log(this.sliderInstance);
    	this.sliderInstance.destroy();
    }
  }
}

customElements.define('slider-flickity', SliderFlickity);


class Testimonial extends HTMLElement {
  constructor() {
    super();
    this.slider = this.querySelector('.testimonial-slider-list');     
    this.sliderItems = this.querySelectorAll('.testimonial-slider-list__item');
    this.sliderView = this.getAttribute('data-view');
    this.items = this.getAttribute('data-items');  
    this.d_items = this.getAttribute('data-desktop');    
    this.m_items = this.getAttribute('data-mobile');  
    this.sliderAlign = this.getAttribute('data-align');  
    this.window = window.innerWidth;
    this.options = {      
      cellAlign: this.sliderAlign,
      contain: true,
      autoPlay: 5000,
//       adaptiveHeight: true,
      wrapAround: true,
      fade: false,      
      pageDots: false,
      arrowShape: 'M96.8,55H22.3l37.4,37.4l-7.1,7.1L3.2,50L52.7,0.5l7.1,7.1L22.3,45h74.6V55z'
    }
    this.sliderInstance;    
    this.initPages();   
    let _this = this;
    
    window.addEventListener('resize', function(){      
      _this.initPages()
    });        
  }
  
  initPages(){   
    let isMobileOrTab = this.isMobileOrTab();       
    isMobileOrTab ? this.initSlider() : this.destroySlider();   
  }

  isMobileOrTab(){    
    let initSlider = false;    
    
    if(window.innerWidth < 749 && this.items > this.m_items){
    	initSlider = true;
    }
    else if(window.innerWidth < 989 && this.items > 3  && this.sliderView == 'desktop'){
    	initSlider = true;
    }
    else if(this.items > this.d_items && this.sliderView == 'desktop'){
    	initSlider = true;
    }
    else{
    	initSlider = false;
    }
    
    return initSlider;
  }
  
  initSlider(){
    setTimeout(() => {
      this.sliderInstance = new Flickity( this.slider, this.options );        
    }, 300);
    //this.sliderInstance = new Flickity( this.slider, this.options );        
  }
  
  destroySlider(){
    if(this.sliderInstance){
      console.log(this.sliderInstance);
    	this.sliderInstance.destroy();
    }
  }
}

customElements.define('testimonial-flickity', Testimonial);

  
  

function smoothScrollTo(hash) {
  if (!hash)
    return;

  $('html, body').animate({
    scrollTop: $(hash).offset().top - 150
  }, 400);
}

$(function() {
  // Smooth scrolling when the page is loaded
  smoothScrollTo(window.location.hash);

  // Smooth scrolling when a link is clicked
  $('a[href^="#"]').click(function() {
    smoothScrollTo(this.hash)
    return false;
  });
});

// const name = document.querySelector(".start_chat_btn__click a");
// name.addEventListener("click", function(){
//   $(".chat-toggle").click();
//   $("#dummy-chat-button-iframe").click()
// });



  // Get the modal
  var modal = document.getElementById("myModal");
  
  // Get the button that opens the modal
  var btn = document.getElementById("myBtn");
  
  // Get the <span> element that closes the modal
  var span = document.getElementsByClassName("close")[0];
  
  // When the user clicks the button, open the modal 
  if(modal){
    if(btn){
      btn.onclick = function() {
        modal.style.display = "block";
      }
    }
    
  
    // When the user clicks on <span> (x), close the modal
    if(span){
      span.onclick = function() {
        modal.style.display = "none";
      }
    }  
    
    // When the user clicks anywhere outside of the modal, close it
    window.onclick = function(event) {
      if (event.target == modal) {
        modal.style.display = "none";
      }
    }
  }  